import { render, staticRenderFns } from "./GavHolidaysCreate.vue?vue&type=template&id=5761b912&scoped=true"
import script from "./GavHolidaysCreate.vue?vue&type=script&lang=js"
export * from "./GavHolidaysCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5761b912",
  null
  
)

export default component.exports